import { useEffect, useRef } from 'react';

export type Callback = () => void;

export const useInterval = (
  callback: Callback,
  delay: number,
  runOnStart = false
) => {
  const intervalFunc = useRef<Callback>(undefined);

  useEffect(() => {
    intervalFunc.current = callback;
  }, [callback]);

  useEffect(() => {
    const tick = () => intervalFunc.current?.();

    if (delay > 0) {
      if (runOnStart) {
        tick();
      }
      const id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay, runOnStart]);
};
